import React from 'react';
import { ExternalLink, BookOpen } from "lucide-react";

const PublicationItem = ({ year, name, link }) => {
  return (
    <div className="group flex gap-4 py-4 px-3 -mx-3 rounded-lg transition-colors hover:bg-gray-50">
      <div className="flex-shrink-0 transition-transform group-hover:scale-105">
        <div className="h-8 w-16 flex items-center justify-center bg-gray-100 rounded-md text-gray-700 font-medium shadow-sm group-hover:shadow group-hover:bg-blue-50 group-hover:text-blue-700 transition-all">
          {year}
        </div>
      </div>
      <div className="flex-grow">
        <h3 className="font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
          {name}
        </h3>
        {link && (
          <a 
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 text-sm text-blue-600 hover:text-blue-800 inline-flex items-center gap-1 
                     transition-all hover:gap-2 opacity-90 hover:opacity-100"
          >
            View Manuscript <ExternalLink size={14} className="transition-transform group-hover:translate-x-1" />
          </a>
        )}
      </div>
    </div>
  );
};

const PublicationsSection = ({user}) => {
  const publications = user?.publications || [];
  const latestYear = publications.length > 0 
    ? Math.max(...publications.map(p => p.year))
    : null;

  if (publications.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6 w-full mx-auto mt-4">
        <div className="text-center py-8">
          <BookOpen className="mx-auto h-12 w-12 text-gray-400" />
          <h3 className="mt-2 text-sm font-semibold text-gray-900">No publications</h3>
          <p className="mt-1 text-sm text-gray-500">
            No publications have been added yet.
          </p>
        </div>
      </div>
    );
  }

  // Create a new array and sort it
  const sortedPublications = [...publications].sort((a, b) => b.year - a.year);

  return (
    <div className="bg-white rounded-lg shadow p-6 w-full mx-auto mt-4">
      <div className="flex justify-between items-center mb-6">
        <div className="space-y-1">
          <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <BookOpen className="h-5 w-5 text-blue-600" />
            Publications
          </h2>
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center bg-blue-50 text-blue-700 text-sm px-2.5 py-0.5 rounded-full font-medium">
              {publications.length} {publications.length === 1 ? 'Publication' : 'Publications'}
            </span>
            {latestYear && (
              <span className="text-sm text-gray-500">
                Latest: {latestYear}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="divide-y divide-gray-100">
        {sortedPublications.map((pub) => (
          <PublicationItem
            key={pub.id}
            {...pub}
          />
        ))}
      </div>
    </div>
  );
};

export default PublicationsSection;